


























































































import { Component, Vue } from 'vue-property-decorator';
import Puzzle from '../components/Puzzle.vue';
import Example from '../components/Example.vue';
import App from '../App.vue';
@Component({
    components: {
        Puzzle,
        Example,
    },
})
export default class Joins extends App {
}
